module.exports = __webpack_public_path__ + "static/img/ic_share.d4dbe9f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/detail/ic_share.svg
// module id = qH66
// module chunks = 10